import { render, staticRenderFns } from "./SearchProductHome.vue?vue&type=template&id=0852a10a&"
import script from "./SearchProductHome.vue?vue&type=script&lang=js&"
export * from "./SearchProductHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports